export enum EMatNemaDuvod {
    NATURAL_PERSONS = 'NATURAL_PERSONS',
    NON_CONSOLIDATING = 'NON_CONSOLIDATING',
    NO_KNOWN_PERSON = 'NO_KNOWN_PERSON',
    NON_PUBLIC = 'NON_PUBLIC'
}
